"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBMediaElement = _interopRequireDefault(require("../../components/HBMediaElement/HBMediaElement"));
var _HBBrandAvatar = require("./HBBrandAvatar.styles");
var HBBrandAvatar = function HBBrandAvatar(_ref) {
  var _ref$company = _ref.company,
    companyName = _ref$company.company_name,
    iconImage = _ref$company.icon_image,
    brandColor = _ref$company.brand_color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    status = _ref.status;
  var companyInitial = (companyName === null || companyName === void 0 ? void 0 : companyName.charAt(0).toUpperCase()) || '';
  var clipPath = status ? getIndicatorClipPath(size) : '';
  var iconPath = (iconImage === null || iconImage === void 0 ? void 0 : iconImage.cloudinary_public_id) || (iconImage === null || iconImage === void 0 ? void 0 : iconImage.url);
  return /*#__PURE__*/_react["default"].createElement(_HBBrandAvatar.BrandAvatarWrapper, {
    $size: size,
    $clipPath: clipPath
  }, /*#__PURE__*/_react["default"].createElement(_HBBrandAvatar.InnerBrandAvatarWrapper, {
    $clipPath: clipPath
  }, iconPath ? /*#__PURE__*/_react["default"].createElement(_HBMediaElement["default"], {
    path: iconPath,
    width: _HBBrandAvatar.LARGE_AVATAR,
    height: _HBBrandAvatar.LARGE_AVATAR,
    crop: "scale"
  }) : /*#__PURE__*/_react["default"].createElement(_HBBrandAvatar.InitialsLogo, {
    $brandColor: brandColor,
    $size: size
  }, /*#__PURE__*/_react["default"].createElement("span", null, companyInitial))), status && /*#__PURE__*/_react["default"].createElement(_HBBrandAvatar.StyledStatusIndicator, {
    status: status
  }));
};
var _default = exports["default"] = HBBrandAvatar;
/**
 * Generates a clip-path for the avatar to create a corner cutout for the status indicator.
 * The path creates a shape that:
 * 1. Starts at top-left (0,0)
 * 2. Goes straight to the right until the cutout
 * 3. Creates a rounded corner cutout using an arc
 * 4. Continues to bottom-right
 * 5. Goes straight down to bottom-left
 * 6. Closes the path back to start
 */
var getIndicatorClipPath = function getIndicatorClipPath(size) {
  var avatarSize = size === 'large' ? _HBBrandAvatar.LARGE_AVATAR : _HBBrandAvatar.SMALL_AVATAR;
  var indicatorSize = _HBBrandAvatar.STATUS_INDICATOR_SIZE / 2 + _HBBrandAvatar.STATUS_INDICATOR_BORDER;
  var cutoutStart = avatarSize - indicatorSize;

  // SVG path commands:
  // M = Move to
  // L = Line to
  // A = Arc (rx ry x-axis-rotation large-arc-flag sweep-flag x y)
  // Z = Close path
  return "\n        clip-path: path(\n            'M 0 0 \n             L ".concat(cutoutStart, " 0 \n             A ").concat(indicatorSize, " ").concat(indicatorSize, " 0 0 0 ").concat(avatarSize, " ").concat(indicatorSize, " \n             L ").concat(avatarSize, " ").concat(avatarSize, " \n             L 0 ").concat(avatarSize, " \n             Z'\n        );\n    ");
};
//# sourceMappingURL=HBBrandAvatar.js.map